/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frames_To_InsertInputs */

const en_frames_to_insert = /** @type {(inputs: Frames_To_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frames to Insert`)
};

const fr_frames_to_insert = /** @type {(inputs: Frames_To_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images à insérer`)
};

const de_frames_to_insert = /** @type {(inputs: Frames_To_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzufügende Rahmen`)
};

const it_frames_to_insert = /** @type {(inputs: Frames_To_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cornici da inserire`)
};

const ru_frames_to_insert = /** @type {(inputs: Frames_To_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рамки для вставки`)
};

const es_frames_to_insert = /** @type {(inputs: Frames_To_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcos para insertar`)
};

const zh_cn2_frames_to_insert = /** @type {(inputs: Frames_To_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`要插入的框架`)
};

const ja_frames_to_insert = /** @type {(inputs: Frames_To_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`挿入するフレーム`)
};

const hi_frames_to_insert = /** @type {(inputs: Frames_To_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सम्मिलित करने के लिए फ़्रेम`)
};

const pt_pt2_frames_to_insert = /** @type {(inputs: Frames_To_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molduras para inserir`)
};

/**
* | output |
* | --- |
* | "Frames to Insert" |
*
* @param {Frames_To_InsertInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const frames_to_insert = /** @type {((inputs?: Frames_To_InsertInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frames_To_InsertInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_frames_to_insert(inputs)
	if (locale === "de") return de_frames_to_insert(inputs)
	if (locale === "it") return it_frames_to_insert(inputs)
	if (locale === "ru") return ru_frames_to_insert(inputs)
	if (locale === "es") return es_frames_to_insert(inputs)
	if (locale === "zh-CN") return zh_cn2_frames_to_insert(inputs)
	if (locale === "ja") return ja_frames_to_insert(inputs)
	if (locale === "hi") return hi_frames_to_insert(inputs)
	if (locale === "pt-PT") return pt_pt2_frames_to_insert(inputs)
	return en_frames_to_insert(inputs)
});